import types from "./languageTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_LANGUAGES:
			return {
				...state,
				loading: false,
				languages: action.payload
			};
		default:
			return state;
	}
};